import request from "@/util/http"; // import qs from 'qs'
// 导航列表查询

export var getNavigationPage = function getNavigationPage(params) {
  return request({
    url: "/admin/navigation/page",
    method: "get",
    params: params
  });
}; // 导航单个删除

export var handleNavigationDelete = function handleNavigationDelete(id) {
  return request({
    url: "/admin/navigation/delete/".concat(id),
    method: "delete"
  });
}; // 导航详情

export var getNavigationInfo = function getNavigationInfo(id) {
  return request({
    url: "/admin/navigation/get/".concat(id),
    method: "get"
  });
}; // 保存导航

export var hallSaveOrUpdate = function hallSaveOrUpdate(data) {
  return request({
    headers: {
      "Content-Type": "application/json"
    },
    url: "/admin/navigation/saveOrUpdate",
    method: "post",
    data: JSON.stringify(data)
  });
};